import { render, staticRenderFns } from "./product.card.vue?vue&type=template&id=77893d6a&"
import script from "./product.card.vue?vue&type=script&lang=js&"
export * from "./product.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports